import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { CMS_BANNER_THEME_TYPES } from './constants';

const BANNER_CLOSE_TYPES = ['white', 'light', 'yellow'];

export const SimpleBanner = ({ children, className, message, onClose, position = 'top', type, unclosable }) => {
  const positionAnimClass = position === 'bottom' ? 'anim--slideInUp' : 'anim--slideInDown';
  return (
    <div
      className={cx(className, 'banner anim', positionAnimClass, {
        [`banner--bottom`]: position === 'bottom',
        [`banner--${type}`]: type,
      })}>
      {!unclosable && (
        <button
          className={cx('banner__close', {
            [`banner__close--${type}`]: BANNER_CLOSE_TYPES.includes(type),
          })}
          onClick={onClose}>
          <Isvg className="svg" uniquifyIDs={false} src={DESIGN_SYSTEM_ICONS.cross} />
        </button>
      )}
      {message ? <LocalizableMessage message={message} /> : children}
    </div>
  );
};

SimpleBanner.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  message: LocalizableMessageShape,
  onClose: PropTypes.func.isRequired,
  position: PropTypes.string,
  type: PropTypes.oneOf(['failure', 'light', 'promo', 'success', ...CMS_BANNER_THEME_TYPES]),
  unclosable: PropTypes.bool,
};
